import React, { useMemo, useState } from 'react';

const PricingView = () => {
    const [teamSize, setTeamSize] = useState(30);
    const [addApi, setAddApi] = useState(false);
    const [addPriority, setAddPriority] = useState(false);
    const [addPrivateHosting, setAddPrivateHosting] = useState(false);

    const quote = useMemo(() => {
        const base = 99;
        const extraUsers = Math.max(0, Number(teamSize || 0) - 30);
        const usersCost = extraUsers * 1.5;
        const optionsCost = (addApi ? 29 : 0) + (addPriority ? 39 : 0) + (addPrivateHosting ? 59 : 0);
        const monthly = base + usersCost + optionsCost;
        return {
            base,
            extraUsers,
            usersCost,
            optionsCost,
            monthly
        };
    }, [teamSize, addApi, addPriority, addPrivateHosting]);

    const paymentLinks = {
        moncash: process.env.REACT_APP_PAYMENT_MONCASH_URL || '#',
        natcash: process.env.REACT_APP_PAYMENT_NATCASH_URL || '#',
        bank: process.env.REACT_APP_PAYMENT_BANK_INFO_URL || '#',
        card: process.env.REACT_APP_PAYMENT_CARD_PROVIDER_URL || '#',
        stripe: process.env.REACT_APP_PAYMENT_STRIPE_URL || '#',
        meru: process.env.REACT_APP_PAYMENT_MERU_URL || '#',
        paypal: process.env.REACT_APP_PAYMENT_PAYPAL_URL || '#',
        wise: process.env.REACT_APP_PAYMENT_WISE_URL || '#'
    };

    const openExternal = (url) => {
        if (!url || url === '#') {
            alert('Lien de paiement non configure. Contactez le support pour activer ce moyen de paiement.');
            return;
        }
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const styles = {
        container: { padding: '30px', maxWidth: '960px', margin: '0 auto' },
        title: { textAlign: 'center', borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '40px' },
        pricingGrid: { display: 'flex', justifyContent: 'center', gap: '30px', flexWrap: 'wrap' },
        plan: { 
            border: '1px solid #ddd', 
            borderRadius: '10px', 
            padding: '30px', 
            width: '280px', 
            textAlign: 'center',
            boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
            display: 'flex',
            flexDirection: 'column'
        },
        planName: { fontSize: '1.5em', marginBottom: '15px' },
        planPrice: { fontSize: '2em', fontWeight: 'bold', color: '#007bff', margin: '10px 0' },
        planFeatures: { listStyle: 'none', padding: 0, textAlign: 'left', margin: '20px 0', flexGrow: 1 },
        featureItem: { marginBottom: '10px' },
        ctaButton: { 
            backgroundColor: '#007bff', 
            color: 'white', 
            border: 'none', 
            padding: '12px 20px', 
            borderRadius: '5px', 
            cursor: 'pointer', 
            textDecoration: 'none',
            marginTop: '20px'
        },
        note: { marginTop: '30px', background: '#f7fbff', border: '1px solid #dbeafe', borderRadius: '10px', padding: '16px', color: '#1f2937', lineHeight: 1.6 },
        quoteBox: { marginTop: '34px', background: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.05)' },
        quoteTitle: { marginTop: 0, marginBottom: '12px' },
        field: { display: 'block', marginBottom: '12px', fontWeight: 600 },
        input: { width: '100%', maxWidth: '240px', marginTop: '6px', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' },
        checkboxRow: { display: 'flex', flexWrap: 'wrap', gap: '16px', marginBottom: '14px' },
        summary: { background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '14px' },
        paymentGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '14px', marginTop: '14px' },
        paymentCard: { background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '12px' },
        muted: { color: '#6b7280', fontSize: '0.95rem' },
        payButton: { marginTop: '8px', backgroundColor: '#0d3b66', color: 'white', border: 'none', padding: '8px 12px', borderRadius: '6px', cursor: 'pointer' }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>Nos Plans Tarifaires</h2>

            <div style={styles.pricingGrid}>
                {/* Plan Essentiel (Gratuit) */}
                <div style={{...styles.plan, borderTop: '5px solid #28a745'}}>
                    <h3 style={styles.planName}>Essentiel</h3>
                    <p style={styles.planPrice}>$0 <span style={{fontSize: '0.5em', color: '#6c757d'}}>/ mois</span></p>
                    <p>Idéal pour démarrer et pour les praticiens solo.</p>
                    <ul style={styles.planFeatures}>
                        <li style={styles.featureItem}>✓ Jusqu'à 50 dossiers patients</li>
                        <li style={styles.featureItem}>✓ Gestion des consultations</li>
                        <li style={styles.featureItem}>✓ Facturation de base</li>
                        <li style={styles.featureItem}>- Support par email</li>
                    </ul>
                    <button type="button" style={styles.ctaButton}>Commencer Gratuitement</button>
                </div>

                {/* Plan Pro */}
                <div style={{...styles.plan, borderTop: '5px solid #007bff'}}>
                    <h3 style={styles.planName}>Pro</h3>
                    <p style={styles.planPrice}>$19 <span style={{fontSize: '0.5em', color: '#6c757d'}}>/ mois</span></p>
                    <p>Pour les cabinets en croissance et les petites équipes.</p>
                    <ul style={styles.planFeatures}>
                        <li style={styles.featureItem}>✓ Dossiers patients illimités</li>
                        <li style={styles.featureItem}>✓ Toutes les fonctionnalités Essentiel</li>
                        <li style={styles.featureItem}>✓ Assistant IA avancé</li>
                        <li style={styles.featureItem}>✓ Support prioritaire</li>
                    </ul>
                    <button type="button" style={styles.ctaButton}>Choisir Pro</button>
                </div>

                {/* Plan Entreprise */}
                <div style={{...styles.plan, borderTop: '5px solid #343a40'}}>
                    <h3 style={styles.planName}>Entreprise</h3>
                    <p style={styles.planPrice}>A partir de $99 <span style={{fontSize: '0.5em', color: '#6c757d'}}>/ mois</span></p>
                    <p>Pour les cliniques, les grands groupes et les besoins spécifiques.</p>
                    <ul style={styles.planFeatures}>
                        <li style={styles.featureItem}>✓ Toutes les fonctionnalités Pro</li>
                        <li style={styles.featureItem}>✓ Déploiement sur site ou cloud privé</li>
                        <li style={styles.featureItem}>✓ Intégrations personnalisées (API)</li>
                        <li style={styles.featureItem}>✓ Manager de compte dédié</li>
                    </ul>
                    <button type="button" style={styles.ctaButton}>Nous Contacter</button>
                </div>
            </div>

            <section style={styles.quoteBox}>
                <h3 style={styles.quoteTitle}>Estimateur de devis Entreprise (USD)</h3>
                <label style={styles.field}>
                    Nombre d'utilisateurs
                    <input
                        type="number"
                        min="1"
                        value={teamSize}
                        onChange={(e) => setTeamSize(e.target.value)}
                        style={styles.input}
                    />
                </label>

                <div style={styles.checkboxRow}>
                    <label><input type="checkbox" checked={addApi} onChange={(e) => setAddApi(e.target.checked)} /> API avancee (+$29)</label>
                    <label><input type="checkbox" checked={addPriority} onChange={(e) => setAddPriority(e.target.checked)} /> Support prioritaire (+$39)</label>
                    <label><input type="checkbox" checked={addPrivateHosting} onChange={(e) => setAddPrivateHosting(e.target.checked)} /> Hebergement prive (+$59)</label>
                </div>

                <div style={styles.summary}>
                    <p>Base entreprise: <strong>${quote.base.toFixed(2)}</strong></p>
                    <p>Supplement utilisateurs ({quote.extraUsers}): <strong>${quote.usersCost.toFixed(2)}</strong></p>
                    <p>Options: <strong>${quote.optionsCost.toFixed(2)}</strong></p>
                    <p><strong>Total estime: ${quote.monthly.toFixed(2)} / mois</strong></p>
                    <p style={styles.muted}>Formule: prix = base + supplement utilisateurs + options.</p>
                </div>
            </section>

            <section style={styles.note}>
                <h3 style={{ marginTop: 0 }}>Moyens de paiement</h3>
                <div style={styles.paymentGrid}>
                    <div style={styles.paymentCard}>
                        <strong>MonCash / NatCash</strong>
                        <p style={styles.muted}>Paiement mobile local pratique en Haiti.</p>
                        <div>
                            <button type="button" style={styles.payButton} onClick={() => openExternal(paymentLinks.moncash)}>Payer via MonCash</button>
                            <button type="button" style={{ ...styles.payButton, marginLeft: '8px' }} onClick={() => openExternal(paymentLinks.natcash)}>Payer via NatCash</button>
                        </div>
                    </div>
                    <div style={styles.paymentCard}>
                        <strong>Virement bancaire</strong>
                        <p style={styles.muted}>Pour contrats Entreprise avec facture officielle.</p>
                        <button type="button" style={styles.payButton} onClick={() => openExternal(paymentLinks.bank)}>Voir instructions virement</button>
                    </div>
                    <div style={styles.paymentCard}>
                        <strong>Carte via fournisseur tiers</strong>
                        <p style={styles.muted}>Le paiement carte se fait sur une page securisee externe.</p>
                        <button type="button" style={styles.payButton} onClick={() => openExternal(paymentLinks.card)}>Payer par carte (tiers)</button>
                    </div>
                    <div style={styles.paymentCard}>
                        <strong>Stripe</strong>
                        <p style={styles.muted}>Paiement carte via Stripe Checkout (page externe securisee).</p>
                        <button type="button" style={styles.payButton} onClick={() => openExternal(paymentLinks.stripe)}>Payer avec Stripe</button>
                    </div>
                    <div style={styles.paymentCard}>
                        <strong>PayPal</strong>
                        <p style={styles.muted}>Paiement en ligne via page officielle PayPal.</p>
                        <button type="button" style={styles.payButton} onClick={() => openExternal(paymentLinks.paypal)}>Payer avec PayPal</button>
                    </div>
                    <div style={styles.paymentCard}>
                        <strong>Wise</strong>
                        <p style={styles.muted}>Paiement international simple en USD.</p>
                        <button type="button" style={styles.payButton} onClick={() => openExternal(paymentLinks.wise)}>Payer avec Wise</button>
                    </div>
                    <div style={styles.paymentCard}>
                        <strong>Meru</strong>
                        <p style={styles.muted}>Paiement via la plateforme Meru (lien externe securise).</p>
                        <button type="button" style={styles.payButton} onClick={() => openExternal(paymentLinks.meru)}>Payer avec Meru</button>
                    </div>
                    <div style={styles.paymentCard}>
                        <strong>Paiement mensuel ou annuel</strong>
                        <p style={styles.muted}>Remise possible pour engagement annuel.</p>
                    </div>
                </div>
                <p style={{ marginTop: '12px', marginBottom: 0 }}>
                    Important: ce site ne collecte pas les numeros de carte bancaire ni les codes secrets.
                    Les paiements sensibles sont traites par un prestataire certifie.
                </p>
                <p style={{ marginTop: '8px', marginBottom: 0 }}>
                    Il s'agit d'un service logiciel (SaaS), sans livraison physique ni shipping.
                </p>
            </section>
        </div>
    );
};

export default PricingView;
